export default {
  line_items: [
    {
      lead_times : [1, 2, 4, 6],
      pricing    : [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
      ],
      quantities: [4, 10, 50, 100],
      product_key: 'fabrication-us-quickturn',
      quote_config_key: 'plx-grpa',
    },
    {
      lead_times : [1, 2, 3, 4, 5],
      pricing    : [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
      ],
      quantities: [4, 10, 50, 100],
      product_key: 'fabrication-us-excell',
      quote_config_key: 'excell-grpb',
    },
    {
      lead_times : [1, 2, 3, 4, 5],
      pricing    : [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
      ],
      quantities: [4, 10, 50, 100],
      product_key: 'fabrication-us-ampel',
      quote_config_key: 'ampel-grpb',
    },
  ],
};
